(() => {
  angular
    .module('gm.common.filters')
    .filter('gmDynamicPrefix', gmDynamicPrefixFilter);

  function gmDynamicPrefixFilter() {
    'ngInject';

    return (origStr, prefix, number) => {
      const str = `${origStr}`;

      return (new Array((number - str.length) + 1)).join(prefix) + str;
    };
  }
})();
